import React from 'react';
import PropTypes from 'prop-types';
import Table from 'antd/lib/table';

const ResponsiveTable = ({ children, ...props }) => {
  return (
    <Table {...props} className="responsive-table">
      {children}
    </Table>
  );
};

ResponsiveTable.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ResponsiveTable;



// WEBPACK FOOTER //
// ./src/common/components/data-display/ResponsiveTable.js